import { render, staticRenderFns } from "./General.vue?vue&type=template&id=be9a53c8&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.scss?vue&type=style&index=0&id=be9a53c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9a53c8",
  null
  
)

export default component.exports